import AddCardOutlinedIcon from "@mui/icons-material/AddCardOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CreditScoreOutlinedIcon from "@mui/icons-material/CreditScoreOutlined";

import Badge from "./Badge";

type OrderStatus = "created" | "captured" | "cancelled";

const statusIcon: Record<OrderStatus, React.FC<{ fontSize: "small" }>> = {
  created: AddCardOutlinedIcon,
  captured: CreditScoreOutlinedIcon,
  cancelled: CancelOutlinedIcon,
} as const;

const statusColor: Record<OrderStatus, Readonly<[string, string]>> = {
  created: ["#BBDEFB", "#1976D2"],
  captured: ["#C8E6C9", "#1B5E20"],
  cancelled: ["#FFCDD2", "#D32F2F"],
} as const;

export const OrderStatusBadge = ({ type }: { type: OrderStatus }) => {
  const [background, foreground] = statusColor[type];
  const Icon = statusIcon[type];

  return (
    <Badge
      backgroundColor={background}
      foregroundColor={foreground}
      icon={<Icon fontSize="small" />}
    />
  );
};
